import React, { Suspense, lazy } from 'react';
import { Box } from '@chakra-ui/react';

// The editor (TipTap/ProseMirror) loads only when editing, keeping it out of the view
// and public page bundles.
const RichTextEditor = lazy(() => import('./RichTextEditor'));

const LazyRichTextEditor = (props) => (
  <Suspense
    fallback={
      <Box minH={props.minH} borderWidth="1px" borderColor="blue.200" borderRadius="md" px={4} py={2} color="gray.500">
        Loading editor…
      </Box>
    }
  >
    <RichTextEditor {...props} />
  </Suspense>
);

export default LazyRichTextEditor;
